import {api} from '../../helpers';
const analysisBaseURL = '/users/kyc-dashboard/verification-analysis';

function fetchVerificationsAnalysis(params) {
  return api.get(`${analysisBaseURL}`, {...params}).then(res => res.data);
}
////////// START ANALYSIS API //////////

function fetchReasonForFailureAnalysis(params) {
  return api
    .get(`${analysisBaseURL}/reason_for_failure`, {
      ...params,
    })
    .then(res => res.data);
}
function fetchCardAnalysis(params) {
  return api
    .get(`${analysisBaseURL}/card`, {
      ...params,
    })
    .then(res => res.data);
}
function fetchChartAnalysis(params) {
  return api
    .get(`${analysisBaseURL}/chart`, {
      ...params,
    })
    .then(res => res.data);
}
function fetchConversionRateAnalysis(params) {
  return api
    .get(`${analysisBaseURL}/conversion_rate`, {
      ...params,
    })
    .then(res => res.data);
}
function fetchPercentageAnalysis(params) {
  return api
    .get(`${analysisBaseURL}/percentage`, {
      ...params,
    })
    .then(res => res.data);
}
function fetchCountryDistributionAnalysis(params) {
  return api
    .get(`${analysisBaseURL}/coutry_distribution`, {
      ...params,
    })
    .then(res => res.data);
}

////////// END ANALYSIS API //////////

function retryVerification(data) {
  return api
    .post(`/users/kyc-dashboard/retry_verification`, {...data})
    .then(res => res.data);
}
function revalidateVerification(data) {
  return api
    .post(`/users/kyc-dashboard/revalidate_verification`, {...data})
    .then(res => res.data);
}
function fetchVerifications(params) {
  return api
    .get(`/users/kyc-dashboard/fetch_verifications`, {params})
    .then(res => res.data);
}
function resendWebhook(verificationId) {
  return api
    .get(
      `/users/kyc-dashboard/resend_webhook?verification_id=${verificationId}`,
    )
    .then(res => res.data);
}

export {
  fetchVerificationsAnalysis,
  fetchReasonForFailureAnalysis,
  retryVerification,
  revalidateVerification,
  fetchVerifications,
  resendWebhook,
  fetchCardAnalysis,
  fetchChartAnalysis,
  fetchConversionRateAnalysis,
  fetchPercentageAnalysis,
  fetchCountryDistributionAnalysis,
};
